// extracted by mini-css-extract-plugin
export var bodySections = "_4q-8";
export var gray = "_4q-7";
export var green = "_4q-4";
export var iconContainer = "_4q-9";
export var iconWidgetContainer = "_4q-1";
export var phoneIcon = "_4q-2";
export var red = "_4q-5";
export var statusDot = "_4q-3";
export var widgetContainer = "_4q-0";
export var yellow = "_4q-6";